// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorReorderReminders = (client) => ({
    /**
     * `POST /vendor/reorder-reminders/settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorReorderRemindersSettingsUpdate
     * @source apps/backend/src/api/vendor/reorder-reminders/settings/route.ts
     */
    createSetting: (body, query, headers) => client.fetch("/vendor/reorder-reminders/settings", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/reorder-reminders/settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorReorderRemindersSettingsRetrieve
     * @source apps/backend/src/api/vendor/reorder-reminders/settings/route.ts
     */
    listSettings: (query, headers) => client.fetch("/vendor/reorder-reminders/settings", { method: "GET", query, headers }),
    /**
     * `GET /vendor/reorder-reminders/orders/:order_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorReorderRemindersOrderRetrieve
     * @source apps/backend/src/api/vendor/reorder-reminders/orders/[order_id]/route.ts
     */
    retrieveOrder: (orderId, query, headers) => client.fetch(buildPath("/vendor/reorder-reminders/orders/:order_id", [orderId]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/reorder-reminders/orders/:order_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorReorderRemindersOrderUpdate
     * @source apps/backend/src/api/vendor/reorder-reminders/orders/[order_id]/route.ts
     */
    updateOrder: (orderId, body, query, headers) => client.fetch(buildPath("/vendor/reorder-reminders/orders/:order_id", [orderId]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=reorder-reminders.js.map